import QuotesList from "./QuotesList";
export default function MyQuotes() { return <QuotesList scope="mine" />; }
